var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgViewDetail = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/View-Detail",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF00",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "remove_red_eye/Outlined",
    transform: "translate(1, 4)",
    fill: "#0A186E",
    fillRule: "nonzero",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,1.37142857 C10.7563636,1.37142857 13.2145452,2.83200008 14.4145452,5.14285714 C13.2145452,7.45371421 10.7636363,8.91428571 8,8.91428571 C5.23636367,8.91428571 2.78545458,7.45371421 1.58545459,5.14285714 C2.78545458,2.83200008 5.24363639,1.37142857 8,1.37142857 Z M8,0 C4.36363636,0 1.25818183,2.13257152 0,5.14285714 C1.25818183,8.15314277 4.36363636,10.2857143 8,10.2857143 C11.6363636,10.2857143 14.7418182,8.15314277 16,5.14285714 C14.7418182,2.13257152 11.6363636,0 8,0 Z M8,3.42857143 C9.00363636,3.42857143 9.81818182,4.19657143 9.81818182,5.14285714 C9.81818182,6.08914285 9.00363636,6.85714286 8,6.85714286 C6.99636364,6.85714286 6.18181818,6.08914285 6.18181818,5.14285714 C6.18181818,4.19657143 6.99636364,3.42857143 8,3.42857143 Z M8,2.05714286 C6.19636362,2.05714286 4.72727273,3.4422857 4.72727273,5.14285714 C4.72727273,6.84342858 6.19636362,8.22857143 8,8.22857143 C9.80363638,8.22857143 11.2727273,6.84342858 11.2727273,5.14285714 C11.2727273,3.4422857 9.80363638,2.05714286 8,2.05714286 Z",
    id: "Vector"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgViewDetail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/View-Detail.44d857ea528495c445b1e0ef313e75dc.svg";